/**
 * Pan cancer dashboard component
 */
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { SessionStorageService } from '@ispm/shared/services/session-storage.service';

@Component({
  selector: 'ispm-pan-cancer-dashboard',
  templateUrl: './pan-cancer-card-dashboard.component.html',
  styleUrls: ['./pan-cancer-card-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('PanCancerCardDashboard')
export class PanCancerCardDashboardComponent implements OnInit, IWidgetItem  {
  widgetUpdateValueCallback: (value) => void;
  config;
  data;

  /**
   * set card dashboard widget config
   * @param _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.config = _itemConfig.widgetPayload;
  }

  widthCalculator(width:number,styles):string{
    const primeWidth = Math.round(width / 8.33);
    let returnStyle = " ispm-card-column ui-g  ui-g-nopad ui-sm-12 ui-md-" + primeWidth + " ui-lg-"+primeWidth+" ui-xl-"+primeWidth;
    return  styles ?  styles+" "+returnStyle : returnStyle;
  }

  trackByFunction(index: number, widget: any){
    return widget?.width;
  }

  /**
   * set card dashboard widget data
   * @param widgetData
   */
  set widgetData(widgetData: any) {
    this.data = widgetData;
  }
  constructor() { }

  ngOnInit() {
    sessionStorage.setItem(SessionStorageService.PREV_DASHBOARD_URL, window.location.href);
  }
}
